import { useI18n } from 'vue-i18n'
import { TYPE, useToast } from 'vue-toastification'
import { CToast } from '@/shared/ui'

export function useCustomToast() {
  const toast = useToast()
  const { t } = useI18n()

  const showToast = ({
    type,
    title,
    message,
    param: _param,
  }: {
    type: TYPE.SUCCESS | TYPE.ERROR | TYPE.WARNING
    title: string
    message: string
    param?: { [p: string]: string | undefined }
  }) => {
    // Translate title and message if they are translation keys
    const translatedTitle = (() => {
      try {
        return t(title) !== title ? t(title) : title
      }
      catch {
        return title
      }
    })()

    const translatedMessage = (() => {
      try {
        return t(message) !== message ? t(message) : message
      }
      catch {
        return message
      }
    })()

    return toast({
      component: CToast,
      props: {
        type,
        title: translatedTitle ?? '',
        message: translatedMessage ?? '',
      },
    })
  }

  const success = ({
    title,
    message,
    param,
  }: {
    title: string
    message: string
    param?: { [p: string]: string | undefined }
  }) => showToast({ type: TYPE.SUCCESS, title, message, param })

  const error = ({
    title,
    message,
    param,
  }: {
    title: string
    message: string
    param?: { [p: string]: string | undefined }
  }) => showToast({ type: TYPE.ERROR, title, message, param })

  const warning = ({
    title,
    message,
    param,
  }: {
    title: string
    message: string
    param?: { [p: string]: string | undefined }
  }) => showToast({ type: TYPE.WARNING, title, message, param })

  return { success, error, warning }
}
